import React, { useEffect } from 'react';
import DisclaimerFooter from '../Disclaimers/DisclaimerFooter';
import { useAuth } from '../../hooks/useAuth';
import '../GuestGate/InsuranceBlur.css';

/**
 * GuestLayout — lightweight wrapper for guest-accessible tool pages.
 * Sticky top bar with logo + phone + login/signup CTAs.
 * Content area + DisclaimerFooter.
 */
function GuestLayout({ children }) {
  const { isLoggedIn } = useAuth();
  useEffect(() => {
    if (!isLoggedIn) {
      document.body.classList.add('guest-mode');
      return () => document.body.classList.remove('guest-mode');
    }
  }, [isLoggedIn]);

  const topBar = {
    position: 'sticky', top: 0, zIndex: 100,
    background: '#FFFFFF',
    borderBottom: '1px solid #E2E8F0',
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  };

  const buttonGhost = {
    display: 'inline-block',
    background: 'transparent',
    border: '1.5px solid #E2E8F0',
    color: '#374151',
    borderRadius: 12,
    padding: '8px 14px',
    fontSize: 12,
    fontWeight: 600,
    textDecoration: 'none',
  };

  const buttonPrimary = {
    display: 'inline-block',
    background: '#1565C0',
    border: '1.5px solid #1565C0',
    color: '#FFFFFF',
    borderRadius: 12,
    padding: '8px 16px',
    fontSize: 12,
    fontWeight: 700,
    textDecoration: 'none',
  };

  const phoneLink = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    textDecoration: 'none',
    color: '#1565C0',
    fontSize: 12,
    fontWeight: 600,
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#F0F4F9' }}>
      <style>{`
        @media (max-width: 640px) {
          .gc-gl-phonetext { display: none; }
          .gc-gl-login { display: none; }
          .gc-gl-logo { height: 28px !important; }
        }
        @media (min-width: 641px) {
          .gc-gl-phonetext { display: inline; }
        }
      `}</style>

      <header style={topBar}>
        <a href="/#/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img
            src="/assets/img/logo_new.svg"
            alt="GetCovered"
            className="gc-gl-logo"
            style={{ height: 32, width: 'auto' }}
          />
        </a>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <a href="tel:888-461-6120" style={phoneLink} aria-label="Call 888-461-6120">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1565C0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <span className="gc-gl-phonetext">888-461-6120</span>
          </a>
          <a href="/#/login" style={buttonGhost} className="gc-gl-login">Log In</a>
          <a href="/#/register" style={buttonPrimary}>Sign Up Free</a>
        </div>
      </header>

      <main style={{ flex: 1, width: '100%', maxWidth: 800, margin: '0 auto', padding: '24px 16px', boxSizing: 'border-box' }}>
        {children}
      </main>

      <DisclaimerFooter />
    </div>
  );
}

export default GuestLayout;
